export default {"src":"/_next/static/media/eclairage.6189c32e.svg","height":64,"width":116,"blurWidth":0,"blurHeight":0};